import { Outlet } from '@tanstack/react-router';
import { useIdleLogout } from '../features/auth/useIdleLogout';

/**
 * Root layout. Renders the active route and arms the app-wide idle-logout
 * watcher (a no-op until a user is authenticated). In its own file so the
 * router module keeps exporting only non-components.
 *
 * The build/environment marker that used to float in the corner here now lives
 * in the footer (AppFooter) — in the shell via AppShell.Footer, and on the
 * public pages via the layouts. That keeps one version display per screen
 * instead of a badge overlapping the footer.
 */
export function RootLayout() {
  useIdleLogout();
  return <Outlet />;
}
